import { Button, ButtonProps } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

type Props = {
  icon?: ReactNode;
  iconClass?: string;
  link?: string;
} & ButtonProps;

export default function ActionButton({
  icon,
  iconClass = "",
  link,
  ...rest
}: Props) {
  const customButton = (
    <Button
      className="flex justify-center items-center !rounded !w-7 !h-7"
      size="large"
      icon={<span className={`relative ${iconClass}`}>{icon}</span>}
      {...rest}
    />
  );

  return link ? <Link to={link}>{customButton}</Link> : customButton;
}
